import type { FaireProductEntity } from "../../entity_types/product";

export const p_mgrax754kx: FaireProductEntity = {
  token: "p_mgrax754kx",
  type: "product",
  name: "Women's Phases of the Moon Socks",
  brandToken: "b_ce2e24c8",
  brandName: "Good Luck Sock",
  imageUrl:
    "https://cdn.faire.com/fastly/837714ecd12ab4c15b886aa61823c7e9dd1c238f3a308ad1e65ca03987fa5258.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/17321db8e07a828f3963b1141416dcc262c1db24391e8cc92065d1d5072bb8c1.jpeg",
    "https://cdn.faire.com/fastly/2c26d821de8548a6bef151202deecc13988fe2cfe13dc216ac1dc048c8dc47e2.jpeg",
    "https://cdn.faire.com/fastly/c4e1abf2be4f364b88865b501ae7590ecb17993375910b1c0bd15eeba2d621fe.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "Wondering about tariffs & duties?\n\nAll orders are duty & tariff free within North America (United States + Canada). The final price on your invoice is the only cost you'll ever see — making it simple, transparent, and risk-free to do business with us.\n\n---\n\nGood Luck Sock offers a huge variety of popular, fun, and modern designs. Reinforced heel & toe for better durability and just the right amount of stretch for all-day comfort.\n\nGood Luck Undies are the ultimate everyday essential. With breathable, moisture-wicking modal-viscose blend fabric and a comfortable fit, there's no pinching, sagging, or adjusting. Just simple underwear that will leave you feeling (and looking) good.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:34.914Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
